import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TypedFormBuilder, TypedFormGroup } from 'formsafe';
import {
  createPrdActionTypes,
  FinalDisciplinaryActionViewModel,
} from 'src/view-models/final-disciplinary-action-view-model';
import { PrdProcessingState } from 'src/view-models/pilot-view-model';
import { PrdProcessingStateSelectItems } from '../pilot-form/pilot-form.component';

@Component({
  selector: 'fl-pilot-final-disciplinary-action-form',
  templateUrl: './pilot-final-disciplinary-action-form.component.html',
  styleUrls: ['./pilot-final-disciplinary-action-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PilotFinalDisciplinaryActionFormComponent implements OnInit {
  @Input()
  public finalDisciplinaryAction?: FinalDisciplinaryActionViewModel;
  @Input()
  public pilotId: string;
  public form: TypedFormGroup<FinalDisciplinaryActionViewModel>;
  public processingStateOptions = PrdProcessingStateSelectItems;
  public actionTypeOptions = createPrdActionTypes().actionTypes;

  public minDate = new Date(1950, 0, 1);
  public maxDate = new Date(Date.now());

  constructor(private _tfb: TypedFormBuilder) {}

  public ngOnInit() {
    const finalDisciplinaryAction: Partial<FinalDisciplinaryActionViewModel> =
      this.finalDisciplinaryAction != null ? this.finalDisciplinaryAction : {};
    this.form = this._tfb.group<FinalDisciplinaryActionViewModel>({
      id: [finalDisciplinaryAction.id],
      actionDate: [finalDisciplinaryAction.actionDate],
      actionType: [finalDisciplinaryAction.actionType],
      lastProcessedDate: [finalDisciplinaryAction.lastProcessedDate],
      pilotId: [this.pilotId],
      prdSourceSystemId: [finalDisciplinaryAction.prdSourceSystemId],
      processingError: [finalDisciplinaryAction.processingError],
      processingState: [
        finalDisciplinaryAction.processingState ?? PrdProcessingState.ReadyForTransmission,
      ],
      relevantDocuments: [finalDisciplinaryAction.relevantDocuments ?? false],
      removalFromOperations: [finalDisciplinaryAction.removalFromOperations ?? false],
      suppressed: [finalDisciplinaryAction.suppressed ?? false],
    });
  }
}
